import { render, staticRenderFns } from "./tab-driving-skills.vue?vue&type=template&id=32239c2b"
import script from "./tab-driving-skills.vue?vue&type=script&lang=js"
export * from "./tab-driving-skills.vue?vue&type=script&lang=js"
import style0 from "./tab-driving-skills.vue?vue&type=style&index=0&id=32239c2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports